import { Phone } from "lucide-react";

export function MobileStickyCallButton() {
  return (
    <div className="xl:hidden fixed bottom-0 left-0 w-full z-40 p-3 bg-background border-t border-border shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
      <a 
        href="tel:+17177257170" 
        className="flex items-center justify-center gap-2 w-full bg-primary text-primary-foreground py-3 px-4 rounded-md font-bold text-lg hover:opacity-90 active:scale-[0.98] transition-all"
        data-testid="btn-mobile-sticky-call"
      >
        <Phone className="h-5 w-5" />
        Call 717-725-7170
      </a>
    </div>
  );
}
